import axios from 'axios'
import { onSuccess, onError, signbeforeRequestSuccess, beforeRequestError, noAuthBeforeRequestSuccess } from '../interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'
import { applicationAuthorization } from '@/api/authorization'

const noAuthClient = axios.create({
  baseURL: process.env.BASE_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': applicationAuthorization(process.env.APPLICATION_KEY)
  }
})

const proxyClient = axios.create({
  baseURL: process.env.BASE_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

proxyClient.interceptors.request.use(signbeforeRequestSuccess, beforeRequestError)
proxyClient.interceptors.response.use(onSuccess, onError)

noAuthClient.interceptors.request.use(noAuthBeforeRequestSuccess, beforeRequestError)
noAuthClient.interceptors.response.use(onSuccess, onError)

export let client = proxyClient
export let noAuth = noAuthClient



// WEBPACK FOOTER //
// ./src/api/base/client.js